import { render } from "./TradeCard.vue?vue&type=template&id=3488f5f8&ts=true"
import script from "./TradeCard.vue?vue&type=script&lang=ts"
export * from "./TradeCard.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__